import BaseModalForm from "./BaseModalForm";
import CustomSearchInput from "../../components/CustomSearchInput";
import CustomSelect from "../../components/CustomSelect";

export default class RegisterAndProposeModal extends BaseModalForm {
    get modalElement() {
        return document.querySelector('.modal#registerAndPropose')
    }

    get formElement() {
        return document.querySelector('.modal#registerAndPropose form')
    }

    init() {
        super.init()
        new CustomSelect(this.formElement.projectDirectionId, {
            panel: {
                floating: false,
                class: 'index-dropdown__head modal-form__input input',
                placeholderClass: 'index-dropdown__placeholder',
                labelClass: 'index-dropdown__select',
            },
        })
        new CustomSearchInput(this.formElement.cityId, {
            url: '/api/cities/paginate'
        })
        new CustomSearchInput(this.formElement.streetId, {
            url: '/api/streets/paginate',
            data: () => {
                return {
                    cityId: this.formElement.cityId.value,
                }
            }
        })
        new CustomSearchInput(this.formElement.houseId, {
            url: '/api/houses/paginate',
            data: () => {
                return {
                    cityId: this.formElement.cityId.value,
                    streetId: this.formElement.streetId.value,
                }
            }
        })
    }

    set phone(phone) {
        this.formElement.phone.value = phone
    }

    get phone() {
        return this.formElement.phone.value
    }

    set code(phone) {
        this.formElement.code.value = phone
    }

    get code() {
        return this.formElement.code.value
    }
}
